import {userConstants} from '../_constants';

export function userCityNpWarehouse(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_USER_CITY_NP_WAREHOUSE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_USER_CITY_NP_WAREHOUSE_SUCCESS:
      return {
        data: action.data,
      };
    case userConstants.GET_USER_CITY_NP_WAREHOUSE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}